import React from 'react';
import { Icon } from './Icon';

const PRESETS = {
  page: 'loader-paw-trail',
  inline: 'loader-paw-spinner',
  dog: 'loader-running-dog',
  cat: 'loader-running-cat',
  typing: 'loader-typing-paws',
  health: 'loader-heartbeat',
  sync: 'loader-bowl-fill',
  playful: 'loader-bouncing-ball',
  success: 'loader-tail-wag',
  bone: 'loader-bone-spinner',
};

/**
 * Brand loading indicator.
 *
 * @example
 *   <Loader />                        // full-page paw trail
 *   <Loader variant="dog" label="Finding caregivers" />
 *   <Loader variant="inline" size="md" />
 */
export function Loader({
  variant = 'page',
  size,
  label = 'Loading',
  className = '',
  showLabel = true,
}) {
  const name = PRESETS[variant] || PRESETS.page;
  const resolvedSize = size || (variant === 'inline' || variant === 'typing' ? 'lg' : '2xl');

  return (
    <div
      className={`inline-flex flex-col items-center justify-center gap-2 text-[var(--pf-ink,#0c0f14)] ${className}`.trim()}
      role="status"
    >
      <Icon name={name} size={resolvedSize} title={label} />
      {showLabel ? <span className="text-sm text-black/55">{label}</span> : null}
    </div>
  );
}

export const LOADER_VARIANTS = Object.keys(PRESETS);

export default Loader;
